export default {
  id: 'expense-import',
  title: 'Import Expense Report',
  category: 'Admin',
  summary: 'Create historical travel, general business, or other direct cost reports on behalf of an employee without involving them in the normal submit flow.',
  overview: 'Proxy import lets administrators enter past expense reports for an employee. You choose the employee and report type, optionally set historical status dates, then create the report and enter details in the normal expense editors with proxy mode enabled. Status notification emails are not sent for proxy-created reports.',
  howItWorks: [
    'From Expense Review, open Import expense report (or go directly to the Import Expense Report page).',
    'Select the employee, expense type (Travel, General Business, or Other Direct Costs), and any historical status dates you need to record.',
    'Create & enter details opens the matching expense editor with proxyImport enabled so you can complete line items, locations, and receipts.',
    'Proxy reports show a Proxy badge and appear under In Progress Imports until finalized.',
    'Finalize moves a completed proxy import into Closed / processed reports. Resume returns a finalized import to In Progress for further edits.'
  ],
  actions: [
    {
      name: 'Import expense report',
      description: 'Opens the proxy import form to choose employee, type, and optional historical dates.'
    },
    {
      name: 'Create & enter details',
      description: 'Creates the report for the employee and navigates into the editor so you can complete the content.'
    },
    {
      name: 'Resume / edit proxy import',
      description: 'Continues an in-progress proxy report from Expense Review → In Progress Imports.'
    },
    {
      name: 'Finalize proxy import',
      description: 'Marks the proxy report processed/closed so it leaves the in-progress import queue.'
    },
    {
      name: 'Resume after finalize',
      description: 'Moves a finalized proxy import back to In Progress Imports if more edits are needed.'
    }
  ],
  tips: [
    'Use proxy import for historical cleanup — employees still see the report on their Expenses list, but they were not asked to submit it.',
    'Proxy creates do not send the usual status emails; communicate separately if the employee needs to know.',
    'Attach receipts and verify project associations before finalizing, just as you would on a normal review.'
  ],
  related: ['expense-review', 'travel-expense', 'general-business', 'other-direct-costs']
};



// WEBPACK FOOTER //
// ./client/help/content/expense-import.js